import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { ButtonProps } from '@sorare/core/src/atoms/buttons/ButtonBase';
import FavoriteHeartButton from '@sorare/core/src/components/favorites/FavoriteHeartButton';
import { cardTypes } from '@sorare/core/src/lib/cards';

import { TokenFavoriteButton_anyCard } from './__generated__/index.graphql';

interface Props extends ButtonProps {
  card: TokenFavoriteButton_anyCard;
  show?: boolean;
  solid?: boolean;
}

const AnimatedWrapper = styled.div<{
  $show?: boolean;
}>`
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
`;

const TokenFavoriteButton = (props: Props) => {
  const { card, show = false, solid = true } = props;
  const subscribable = {
    __typename: cardTypes[card.sport],
    slug: card.slug,
  };

  return (
    <AnimatedWrapper $show={show}>
      <FavoriteHeartButton
        small
        subscribable={subscribable}
        solid={solid}
        currentUserSubscription={card.currentUserSubscription}
      />
    </AnimatedWrapper>
  );
};

TokenFavoriteButton.fragments = {
  anyCard: gql`
    fragment TokenFavoriteButton_anyCard on AnyCardInterface {
      slug
      sport
      currentUserSubscription {
        slug
      }
    }
  ` as TypedDocumentNode<TokenFavoriteButton_anyCard>,
};

export default TokenFavoriteButton;
